import React from 'react'
import Footer from '../Common/Footer'
import "../css/TermsOfServices.css";
import Header from '../Common/Header';
export default function TermsOfServices() {
  return (
 <>
 <Header />
     <div className="terms-container">
      <div className="terms-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: July 28, 2025</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using our WhatsApp-based service or any other platform provided by SessLink, you agree to be bound by these Terms of Service. If you do not agree, you may not use the service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Our chatbot service allows you to communicate with us via WhatsApp for the purposes of receiving information, support, updates, or performing specific interactions like order tracking or account inquiries.
          </p>
        </section>

        <section>
          <h2>3. User Responsibilities</h2>
          <p>By using our services, you agree to:</p>
          <ul>
            <li>Use the service only for lawful purposes</li>
            <li>Not abuse or spam the chatbot system</li>
            <li>Not attempt to harm or reverse-engineer the service</li>
          </ul>
        </section>

        <section>
          <h2>4. Data and Privacy</h2>
          <p>
            We collect and use data in accordance with our <a href="/privacy-policy">Privacy Policy</a>. By using our services, you agree to such data collection and usage.
          </p>
        </section>

        <section>
          <h2>5. Limitation of Liability</h2>
          <p>
            [Your Company Name] is not responsible for any damages or losses resulting from the use or inability to use the service, including but not limited to message delivery delays, interruptions, or data errors.
          </p>
        </section>

        <section>
          <h2>6. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to the service at any time, for any reason, including violation of these terms.
          </p>
        </section>

        <section>
          <h2>7. Modifications</h2>
          <p>
            We may update or modify these Terms of Service at any time. Updates will be effective upon posting. Continued use of the service constitutes acceptance of the modified terms.
          </p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Service, contact us at <a href="mailto:support@sesslink.com">support@sesslink.com</a>.
          </p>
        </section>
      </div>
    </div>
    <Footer />
 </>
  )
}
